import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Pagination from '../pagination/Pagination.jsx'
import Button from '../Button.jsx'
import Flash from '../flash/Flash.jsx'
import { ListTeams } from '../../repo/TeamsRepo.js'
import { DeleteTeam } from '../../repo/TeamsRepo.js'

export default function AdminTeamsList() {
  // The URL query string is the single source of truth for page and name
  // filter: setSearchParams updates the address bar and keeps React Router in
  // sync, so the list is bookmarkable and back/forward work.
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get('page') || "1";
  const nameParam = searchParams.get('name') || "";

  const [teams, setTeams] = useState([])
  const [pagination, setPagination] = useState(null)
  const [showFlashMessage, setShowFlashMessage] = useState(false)
  // Local state for the controlled input, seeded from the URL and kept in sync
  // with it below so back/forward navigation updates the box too.
  const [nameFilter, setNameFilter] = useState(nameParam)

  const handlePaginationClick = (newTeamsPage) => {
    setSearchParams(buildSearchParams(newTeamsPage, nameParam))
  }

  const handleDeleteTeamClick = (teamId) => {
    if (window.confirm("Delete?")) {
      deleteTeam(teamId).then(deleted => {
        if (deleted) {
          setSearchParams(buildSearchParams("1", nameParam))
          setShowFlashMessage(true)
        }
      })
    }
  }

  const handleEditTeamClick = (teamId) => {
    window.location.href = "/cocofantoelefanto/teams/" + teamId + "/edit"
  }

  const handleFilterSubmit = (event) => {
    event.preventDefault()
    setSearchParams(buildSearchParams("1", nameFilter))
  }

  // Keep the input in sync with the URL (e.g. when navigating back/forward).
  useEffect(() => {
    setNameFilter(nameParam)
  }, [nameParam])

  useEffect(() => {
    loadTeams(page, nameParam)
  }, [page, nameParam])

  async function loadTeams(page, name) {
    const resData = await ListTeams(page, { filters: { name } })

    setTeams(resData.data)
    setPagination(resData.pagination)
  }

  return (
    <>
      {showFlashMessage && (
        <Flash message="Team was successfully deleted" type="success" timer={5000}/>
      )}

      <form onSubmit={handleFilterSubmit} className="flex items-center gap-2 mt-4">
        <input
          type="text"
          value={nameFilter}
          onChange={(event) => setNameFilter(event.target.value)}
          placeholder="Filter by name"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-64 p-2.5"
        />
        <Button type="submit" styleName="dark">Search</Button>
      </form>

      <table className="w-full text-sm text-left rtl:text-right text-gray-500 mt-4">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
          <tr>
            <th scope="col" className="px-6 py-3 w-24">Escudo</th>
            <th scope="col" className="px-6 py-3">Name</th>
            <th scope="col" className="px-6 py-3">API/ID</th>
            <th scope="col" className="px-6 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
        {teams.map((team) => {
          return (
            <tr key={team.id} className="odd:bg-white even:bg-gray-50 border-b border-gray-200">
              <td className="px-4 py-2">
                <img src={team.badge_thumb} alt={team.name}/>
              </td>
              <td className="px-4 py-2">
                <Link className="hover:no-underline underline" to={`/cocofantoelefanto/teams/${team.id}`}>{team.name}</Link>
              </td>
              <td className="px-4 py-2">
                {team.third_party_label ? team.third_party_label : "-"}/{team.third_party_id ? team.third_party_id : "-"}
              </td>
              <td className="px-4 py-2 space-x-2">
                <Button styleName="yellow" onClick={() => handleEditTeamClick(team.id)}>Edit</Button>
                <Button styleName="red" onClick={() => handleDeleteTeamClick(team.id)}>Delete</Button>
              </td>
            </tr>
          )
        })}
        </tbody>
      </table>

      <Pagination pagination={pagination} onPaginationClick={handlePaginationClick} />
    </>
  )
}

// Builds the query string, omitting an empty name so the URL stays clean
// (e.g. "?page=2" rather than "?page=2&name=").
function buildSearchParams(page, name) {
  const params = { page: String(page) }
  if (name) {
    params.name = name
  }
  return params
}

async function deleteTeam(teamId) {
  return DeleteTeam(teamId)
}
